import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TodoCategoryEditor.html?raw';
import lang from 'dojo/_base/lang';

import MainCatalogsEditorBaseV2 from '../MainCatalogsEditorBaseV2';
import { MainCatalogs_Classes } from "../../_loadingHelpers/MainCatalogTypes";
import { ExpandableSection, ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { TodoDescriptionEditor } from "../MainCatalogEditorTools";
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';


interface TodoDescriptionEntry {
    ID: string;
    isDeleted?: boolean;
    isNew?: boolean;
}
class TodoCategoryEditor extends compose(MainCatalogsEditorBaseV2) {
    templateString: any = template;

    private expanderTodoDescriptions: MdsLax<InstanceType<typeof ExpandableSection>>
    private selectedDescriptions: Array<TodoDescriptionEntry> = [];
    //private inputTodoDescriptions: HintBox;
    private descriptionsTable: MdsLax<InstanceType<typeof StaticTable>> = null;
    private tableContainer: HTMLElement;

    private _updateTableTimeoutHandler: any = null;

    isValid(): boolean {
        //Need to implement
        return true;
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        this.selectedDescriptions = lang.clone(this.getAttributeValue("todoDescriptions"));

        if (this._updateTableTimeoutHandler != null) {
            clearTimeout(this._updateTableTimeoutHandler);

            this.updateDescriptionsTable();
        }
    }

    protected _setEntityClass(): void {
        //You need to set this to Entity class of the editor
        this.entityClass = MainCatalogs_Classes.TodoCategory;
    }

    private updateDescriptionsTable() {
        this.StandbyStop("tableLoad");
        let selecteDescriptions: Array<TodoDescriptionEntry> = lang.clone(this.getAttributeValue("todoDescriptions"));

        selecteDescriptions?.length > 0 ? this.expanderTodoDescriptions.setMarking(ExpandableSectionMarkings.hasContent) : this.expanderTodoDescriptions.setMarking(ExpandableSectionMarkings.default);

        this.descriptionsTable.setData(selecteDescriptions);

        selecteDescriptions?.forEach(s => {
            if (s.isDeleted === true) {
                this.disableNode(this.descriptionsTable.getRowGroupByKeyValue(s.ID, "ID").rows[0].node);
            }
        })
    }
    private _onRowClick(row: StaticTable.StaticTableRow<TodoDescriptionEntry>) {

        this.requestNewTodoDescriptionEditor(row.rowGroup.entity, row.rowGroup.displayname)
    }
    private requestNewTodoDescriptionEditor(entity?: any, displayname?: string) {

        let entityId = null;
        let form = null;
        if (entity) {
            try {
                entityId = entity.ID;
            } catch (ex) {
                alert("no ID-Property set for clicked entity!");
                return;
            }

        }

        if (!displayname) {
            displayname = this.translate("General_Loading");
        }

        let newLabel = this.translate("General_CreateNew") + " - " + this.translate("General_Label_TodoDescription");
        form = new TodoDescriptionEditor();

        if (this.isEmbeddedInTab) {
            this.requestNewTabbedContent({
                enableClosing: true,
                label: entityId ? displayname : newLabel,
                sidebarEntryName: entityId ? entityId : "new-" + MainCatalogs_Classes.TodoDescription,
                name: entityId ? entityId : "_blank",
                widget: form,
                coloration: this.tabColor,
                groupLabel: displayname
            }, true);
        } else {
            //Show dlg
            var dlg = new GenericDialog();

        }

        if (entityId) {
            form.loadEntity(entityId);
        } else {
            form.updateHeading(newLabel);
            form.setStartupState("ready");
        }
    }
    private _setUpTable(response: { layouts: Array<any> }) {

        if (this.descriptionsTable != null) this.descriptionsTable.destroy();

        this.descriptionsTable = new StaticTable();
        this.descriptionsTable.placeAt(this.tableContainer);

        this.descriptionsTable.setLayout(response.layouts[0]);
        //this.descriptionsTable.addDefaultRowActionButton("delete", lang.hitch(this, this.removeDescription));

        this.descriptionsTable.setRowClick(lang.hitch(this, this._onRowClick))
        this.descriptionsTable.setCyAttribute("TodoCategoryEditorDescriptionTable");

        this._updateTableTimeoutHandler = setTimeout(() => {
            this.updateDescriptionsTable();
        }, 500);
    }

    private removeDescription(rowGr: StaticTable.StaticTableRowGroup<TodoDescriptionEntry>) {

        let entry = rowGr.entity;
        let deletedResource = this.selectedDescriptions.filter(x => x.ID === entry.ID /*&& x.assignmentID === entry.assignmentID*/)[0];

        if (entry.isNew) {

            this.selectedDescriptions.splice(this.selectedDescriptions.indexOf(deletedResource), 1);
        } else {

            deletedResource.isDeleted = true;
        }

        this.setAttributeValue("todoDescriptions", lang.clone(this.selectedDescriptions));
        this.updateDescriptionsTable();
    }

    protected beforeDelete() {
        let todoDescriptions = this.getAttributeValue("todoDescriptions");
        if (todoDescriptions && todoDescriptions.length > 0) {
            this.showToast(this.translate("TodoCategory_Error_NoDelete"), "fas fa-exclamation-triangle");
            return;
        }
        super.beforeDelete.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.StandbyStart(this.expanderTodoDescriptions.domNode, "tableLoad");
        this.RequestManager.callfunction(
            "Webtool__MainCatalogsEditor_GetTodoDescriptionsTable",
            null,
            lang.hitch(this, this._setUpTable),
            (err) => { this.showToast(err.Message) }
        )
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(TodoCategoryEditor);